"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18.16",
    height: "11",
    viewBox: "0 0 18.16 11",
    fill: "#dadbd8"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1,4.5H7.9L6.07,2.67a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0L11,4.79a1,1,0,0,1,0,1.42L7.49,9.74a1,1,0,0,1-1.42,0,1,1,0,0,1,0-1.41L7.9,6.5H1a1,1,0,0,1,0-2Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.16,11a1,1,0,0,1-1-1V1a1,1,0,0,1,2,0v9A1,1,0,0,1,15.16,11Z"
  }));
};

exports["default"] = _default;